export default function ModulePopRecordUncomfortableStatistic({
  prePopOption,
  closePrePop,
}) {
  console.log(prePopOption);
  return (
    <>
      <div className="px-3">
        <table className="w-full custom-tb text-center">
          <thead>
            <tr className="bg-blue-50">
              <th>症狀</th>
              <th>發生日期/次數</th>
            </tr>
          </thead>
          <tbody>
            {prePopOption.data.map((item) => (
              <tr key={`symptom_${item.label}`}>
                <td>{item.label}</td>
                <td>
                  {item.data.map((dates) => (
                    <div
                      key={`symptom_${item.label}_${item.label}`}
                      className=""
                    >{`${dates.date}：${dates.count}`}</div>
                  ))}
                </td>
              </tr>
            ))}
            {prePopOption.data.length === 0 && (
              <tr>
                <td className="text-red-400" colSpan={2}>
                  無資料
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
}
